
/*Page types*/

/* Fetching statuses */
export const FETCH_REQUESTED = 'FETCH_REQUESTED';
export const FETCH_RECEIVED = 'FETCH_RECEIVED';
export const FETCH_FAILED = 'FETCH_FAILED';

/*Chart*/
export const SELECT_CHART_TYPE = 'SELECT_CHART_TYPE';
export const CHART_TYPE_FREQUENCY_HEATMAP = 'CHART_TYPE_FREQUENCY_HEATMAP';
export const CHART_TYPE_FREQUENCY_LINE = 'CHART_TYPE_FREQUENCY_LINE';
export const CHART_TYPE_FREQUENCY_LINE_5MIN = 'CHART_TYPE_FREQUENCY_LINE_5MIN';
export const CHART_TYPE_FREQUENCY_LINE_DUID = 'CHART_TYPE_FREQUENCY_LINE_DUID';
export const CHART_TYPE_PORTLAND_LINE = 'CHART_TYPE_PORTLAND_LINE';
export const CHART_TYPE_GENERATION_LINE_DUID = 'CHART_TYPE_GENERATION_LINE_DUID';

export const REQUESTED_FREQUENCY_HEATMAP_DATA = 'REQUESTED_FREQUENCY_HEATMAP_DATA';
export const RECEIVED_FREQUENCY_HEATMAP_DATA = 'RECEIVED_FREQUENCY_HEATMAP_DATA';
export const FAILED_FREQUENCY_HEATMAP_DATA = 'FAILED_FREQUENCY_HEATMAP_DATA';
export const REQUESTED_FREQUENCY_HEATMAP_COLOR_RANGE = 'REQUESTED_FREQUENCY_HEATMAP_COLOR_RANGE';
export const RECEIVED_FREQUENCY_HEATMAP_COLOR_RANGE = 'RECEIVED_FREQUENCY_HEATMAP_COLOR_RANGE';
export const FAILED_FREQUENCY_HEATMAP_COLOR_RANGE = 'FAILED_FREQUENCY_HEATMAP_COLOR_RANGE';

export const REQUESTED_FREQUENCY_LINE_DATA = 'REQUESTED_FREQUENCY_LINE_DATA';
export const RECEIVED_FREQUENCY_LINE_DATA = 'RECEIVED_FREQUENCY_LINE_DATA';
export const FAILED_FREQUENCY_LINE_DATA = 'FAILED_FREQUENCY_LINE_DATA';

export const REQUESTED_FREQUENCY_LINE_DUID_DATA = 'REQUESTED_FREQUENCY_LINE_DUID_DATA';
export const RECEIVED_FREQUENCY_LINE_DUID_DATA = 'RECEIVED_FREQUENCY_LINE_DUID_DATA';
export const FAILED_FREQUENCY_LINE_DUID_DATA = 'FAILED_FREQUENCY_LINE_DUID_DATA';

export const REQUESTED_GENERATION_LINE_DUID_DATA = 'REQUESTED_GENERATION_LINE_DUID_DATA';
export const RECEIVED_GENERATION_LINE_DUID_DATA = 'RECEIVED_GENERATION_LINE_DUID_DATA';
export const FAILED_GENERATION_LINE_DUID_DATA = 'FAILED_GENERATION_LINE_DUID_DATA';

export const REQUESTED_PORTLAND_DATA= 'REQUESTED_PORTLAND_DATA';
export const RECEIVED_PORTLAND_DATA = 'RECEIVED_PORTLAND_DATA';
export const FAILED_PORTLAND_DATA = 'FAILED_PORTLAND_DATA';

export const REQUESTED_DUIDLIST = 'REQUESTED_DUIDLIST';
export const RECEIVED_DUIDLIST = 'RECEIVED_DUIDLIST';
export const FAILED_DUIDLIST = 'FAILED_DUIDLIST';

/* Loggers */
export const LOGGER_USER_ACTIVITY = 'FCASPAYS_USER_ACTIVITY';
export const LOGGER_APP_ERROR = 'FCASPAYS_APP_ERROR';

/* User */
export const GOT_USER_INFO = 'GOT_USER_INFO';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_UNAUTHENTICATED = 'USER_UNAUTHENTICATED';



// WEBPACK FOOTER //
// ./src/constants/index.js